module.exports = __webpack_public_path__ + "img/1491499979.ed274dd2.jpg";